import React from 'react';
import { Alert, Button, message } from 'antd';
import { useDispatch, useSelector } from 'react-redux';
import JSZip from 'jszip';
import moment from 'moment';
import { requestsActions } from '../../../Requests/requests.actions';
import { downloadFile } from '../../../../helpers/downloadFile';

const translatedErrors = {
  "Data too long for column 'vDescription' at row": 'Слишком длинное описание',
};

const getErrorText = (originalText) => {
  const pair = Object.entries(translatedErrors).find(([en, _ru]) =>
    originalText.startsWith(en)
  );
  return pair ? pair[1] : originalText;
};

export const ImportFromCityPortalAlertError = () => {
  const dispatch = useDispatch();
  const importResult = useSelector((state) => state.requestsStore.importResult);

  if (!importResult?.errorFiles?.length) {
    return null;
  }

  const handleDownloadAll = () => {
    const zip = new JSZip();
    importResult.errorFiles.forEach((err) => {
      zip.file(err.fileName, err.fileWrapper.originalFileObj);
    });
    zip.generateAsync({ type: 'blob' }).then(
      (blob) => {
        const url = window.URL.createObjectURL(blob);
        const dateTime = moment().utc().format('DD_MM_YYYY HH_mm_ss');
        downloadFile({
          url,
          fileName: `import_errors (${dateTime}).zip`,
          revoke: true,
        });
      },
      (err) => {
        message.error(`Произошла ошибка при формировании архива (${err})`);
      }
    );
  };

  const revokeAllUrl = () => {
    importResult.errorFiles.forEach((err) => {
      window.URL.revokeObjectURL(err.fileUrl);
    });
  };

  return (
    <Alert
      onClose={() => {
        const newValue = importResult?.createdRequestIds?.length
          ? {
              ...importResult,
              errorFiles: [],
            }
          : null;
        dispatch(requestsActions.setImportResult(newValue));
        revokeAllUrl();
      }}
      message={
        <div>
          <div>Не все заявки были созданы:</div>
          <ul style={{ listStyleType: 'none' }}>
            {importResult.errorFiles.map((err) => {
              return (
                <li key={err.fileName}>
                  <a
                    href={err.fileUrl}
                    download={err.fileName}
                  >
                    {err.fileName}
                  </a>{' '}
                  (Ошибка: {getErrorText(err.error)})
                </li>
              );
            })}
          </ul>
          <div>
            <Button onClick={handleDownloadAll}>Скачать все</Button>
          </div>
        </div>
      }
      type="error"
      closable
      showIcon={false}
      banner
    />
  );
};
